import { render } from "./ChangeStatusAccount.vue?vue&type=template&id=6fb0c796"
import script from "./ChangeStatusAccount.vue?vue&type=script&lang=js"
export * from "./ChangeStatusAccount.vue?vue&type=script&lang=js"

import "./ChangeStatusAccount.vue?vue&type=style&index=0&id=6fb0c796&lang=scss"

import exportComponent from "/opt/app-root/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__